export default "__VITE_ASSET__BYj8IuWr__"